export const SCREENS = {
  mobile: "320px",
  tablet: "768px",
  desktop: "1024px",
  fullScreen: "1440px",
};
